import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Button, Container, Grid, TextField } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import phoneFormatter from 'phone-formatter'
import React, { useContext, useState } from "react"
import { useHistory } from "react-router-dom"
import Utilities from '../classes/Utilities'
import Heading from '../components/Heading'
import { AppContext } from '../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))

export default function VerifySMS(props) {
    const { paths, user, showMessage, showError, socket } = useContext(AppContext)
    const history = useHistory()
    const [waiting, setWaiting] = useState(false)
    const [codeSent, setCodeSent] = useState(false)
    const classes = useStyles()
    const smsMasked = phoneFormatter.format(user.sms, '(NNN) NNN-NNNN')

    async function handleRequestCode() {
        try {
            const response = await socket.send('verifySMS', {
                step: 'requestCode',
            })

            showMessage(response, { variant: 'success' })
            setCodeSent(true)
        } catch (err) {
            showError(err)
        }
    }

    async function handleSubmitCode(event) {
        event.preventDefault()

        setWaiting(true)

        try {
            const values = Utilities.getFormValues(event.target)

            const response = await socket.send('verifySMS', {
                step: 'validateCode',
                code: values.code,
            })

            showMessage(response, { variant: 'success' })
            history.goBack()

        } catch (err) {
            showError(err)
            setWaiting(false)
        }
    }

    return (
        <Container maxWidth="xs">
            <Heading icon={<LockOutlinedIcon />}>
                Verify Mobile Number
            </Heading>
            {codeSent &&
                <form className={classes.form} onSubmit={handleSubmitCode}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id="code"
                                name="code"
                                label="Authorization Code"
                                variant="outlined"
                                required
                                fullWidth
                                disabled={waiting}
                                autoFocus
                            />
                        </Grid>
                    </Grid>
                    <Button
                        className={classes.submit}
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={waiting}
                    >
                        Verify
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        fullWidth
                        disabled={waiting}
                        onClick={() => { history.push(paths.account) }}
                    >
                        Cancel
                    </Button>
                </form>
            }
            {!codeSent &&
                <form className={classes.form}>
                    <Button
                        className={classes.submit}
                        type="button"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={waiting}
                        onClick={() => { handleRequestCode() }}
                    >
                        Send code via SMS<br />{smsMasked}
                    </Button>
                    <Button
                        className={classes.submit}
                        type="button"
                        variant="contained"
                        color="secondary"
                        fullWidth
                        disabled={waiting}
                        onClick={() => { history.push(paths.account) }}
                    >
                        Cancel
                    </Button>
                </form>
            }
        </Container>
    )
}
